import store from "@/store";
import _ from "lodash";

export default {
  data() {
    return {
      func: [{
        name: "產品連結",
        values: "product"
      }, {
        name: "文章連結",
        values: "document"
      }],

      field: [{
        name: "暫存",
        field: "isonline",
        type: "text"
      }, {
        name: "主標題",
        field: "name",
        type: "text"
      }, {
        name: "次標題",
        field: "smallName",
        type: "text"
      }, {
        name: "標示",
        field: "forText",
        type: "text"
      }, {
        name: "結束時間",
        field: "endTime",
        type: "date"
      }, {
        name: "圖片",
        field: "image",
        type: "text"
      }, {
        name: "連結網址",
        field: "url",
        type: "text"
      }, {
        name: "內容說明",
        field: "content",
        type: "text"
      }, {
        name: "分類",
        field: "func",
        type: "option"
      }, {
        name: "背景顏色",
        field: "backColor",
        type: "color"
      }, {
        name: "圖示",
        field: "icon",
        type: "text"
      }, {
        name: "資料來源",
        field: "sourceData",
        type: "text"
      }, {
        name: "圖片按鈕",
        field: "btnImage",
        type: "text"
      }, {
        name: "圖片連結",
        field: "btnUrl",
        type: "text"
      }, ],

      blockModel: [{
        name: "幻燈片模式",
        values: "slide",
      }, {
        name: "快捷鍵模式",
        values: "hotkey",
      }, {
        name: "多產品模式",
        values: "multiProduct",
      }, {
        name: "單產品模式",
        values: "singleProduct",
      }, {
        name: "清單模式",
        values: "list"
      }],

      multiProductModel: [{
        name: "水平拖移",
        values: "horizontalScroll",
        subModel: [{
          name: "固定寬度",
          values: "fixed"
        }, {
          name: "浮動寬度",
          values: "float"
        }],
      }],

      singleProductModel: [{
        name: "圖文說明",
        values: "imageAndContent",
        subModel: [{
          name: "左文字、右圖片",
          values: "leftContentRightImage"
        }]
      }],

      defaultBlock: {
        delete: false,
        model: "",
        title: {
          name: "",
          bName: "",
          linkName: "",
          linkUrl: "",
          backImage: "",
        },
        slide: {
          model: "",
          timer: {
            show: false,
          },
          hotSearch: {
            show: false,
          },
        },
        hotkey: {
          model: ""
        },
        multiProduct: {
          model: "",
          subModel: "",
          submitName: "",
        },
        singleProduct: {
          model: "",
          subModel: "",
          submitName: "",
        },
        list: {
          model: "",
          subModel: "",
          submitName: "",
        },
      },

      manage: {
        open: false,
        model: "",
      },

      manageTemp: {
        open: false,
        data: {
          name: "",
          url: "",
          image: "",
          backColor: ""
        }
      }
    }
  },

  computed: {
    blockList: {
      get() {
        return this.$store.state.web.block;
      },
      set() {
        
      }
    },
    filterDelete() {
      return (list) => {
        return _.filter(list, {
          "delete": false
        });
      }
    },

    checkSubModel() {
      return (model, modelList) => {
        let temp = _.filter(modelList, (item, key) => {
          return (item.values == model);
        });

        let subModel = (temp.length > 0) ? (temp[0].subModel.length > 0) : false;

        return subModel;
      };
    },

    getSubModel() {
      return (model, modelList) => {
        let temp = _.filter(modelList, (item, key) => {
          return (item.values == model);
        });

        let subModel = (temp.length > 0) ? ((temp[0].subModel.length > 0) ? temp[0].subModel :
        []) : [];

        return subModel;
      };
    },

    getFirst() {
      return (list) => {
        return _.filter(list, (item, key) => {
          return key == 0;
        })
      }
    },

    getModelName() {
      return (model) => {
        return "列表";
      }
    },

    getField() {
      return () => {
        let temp = ["isonline", "name", "smallName", "forText", "endTime", "url", "image",
          "content", "backColor", "func", "icon", "sourceData", "btnImage", "btnUrl"
        ];

        switch (this.manage.model) {
          case "slide":
            temp = ["isonline", "name", "image", "url", "backColor"];
            break;
          case "hotkey":
            temp = ["isonline", "icon", "name", "smallName", "url", "func"];
            break;
          case "multiProduct":
            temp = ["isonline", "name", "smallName", "content", "forText", "image", "url", "func",
              "sourceData"
            ];
            break;
          case "singleProduct":
            temp = ["isonline", "name", "smallName", "content", "forText", "image", "url", "func",
              "sourceData"
            ];

            if (this.manage.subModel == "leftContentRightImage") {
              temp = ["isonline", "name", "smallName", "content", "forText", "image", "url",
                "func", "sourceData", "btnImage", "btnUrl"
              ];
            }

            break;
          case "list":
            temp = ["isonline", "name", "smallName", "url", "content"];
            break;
        }

        let field = _.mapValues(temp, (item) => {
          return _.find(this.field, {
            field: item
          });
        });

        return field;
      }
    },

    orderBy() {
      return (arrayList) => {
        return _.orderBy(arrayList, ['orders'], ['asc']);
      }
    }
  },

  methods: {
    upChange(index) {
      const deleteIndex = index + 1;
      this.blockList.splice(index - 1, 0, this.blockList[index]);
      this.blockList.splice(deleteIndex, 1);

      this.refreshOrderBlockList();
    },
    downChange(index) {
      const deleteIndex = index;
      this.blockList.splice(index + 2, 0, this.blockList[index]);
      this.blockList.splice(deleteIndex, 1);
      this.refreshOrderBlockList();
    },

    refreshOrderBlockList() {
      this.blockList = _.mapValues(this.blockList, (item, key) => {
        item.orders = key;
        return item;
      })
    },

    createBlock() {
      let temp = JSON.parse(JSON.stringify(this.defaultBlock));
      this.blockList.push(temp);
    },

    deleteBlock(data) {
      data.delete = true;
    },

    saveWebSetting() {
      this.$store.dispatch("web/saveWebSetting", this.blockList);
    },

    gotoPage(page, save = false) {
      if (save) {
        this.saveWebSetting();
      }
      this.$router.push({
        name: page
      });
    },

    // modal 
    manageSave(online = true) {

      let temp = this.manageTemp;
      temp.isonline = online;
      temp.belong_list = this.manage.uid;
      this.$store.dispatch("web/saveModelList", temp);
    },

    openManagement(model, block = null) {
      this.manage.open = true;
      this.manage.model = model;
      this.manage.subModel = block[model].subModel || block[model].model;
      this.manage.uid = block.uid;
      this.manage.data = block.dataList;
    },

    openInsertOrUpdate(method, model, data = null) {
      this.manageTemp.open = true;
      this.manageTemp.method = method;
      this.manageTemp.model = model;
      if (data) {
        this.manageTemp.data = JSON.parse(JSON.stringify(data));
      } else {
        this.manageTemp.data = {}
      }
    },

    deleteModelList() {
      this.$store.dispatch("web/deleteModelList", this.manageTemp.data);
    }


  },

  mounted() {
    this.$store.dispatch("web/getWebSetting");
  }
}
